<script setup lang="ts">
import type { PropertyId } from "~/classes/entity"
import type { PropertyColor, PropertySize } from "~/classes/generated/interface"

const props = defineProps({
  file: null,
  propertyId: null,
  size: null,
  color: null,
  selected: { type: Boolean },
  diff: null,
  multiline: { type: Boolean },
  maxLines: null
})
const { getPropertyAsDiff } = useProperty()
const propertyDiff = computed(() => props.diff ? getPropertyAsDiff(props.file, props.diff, props.propertyId) : undefined)
</script>

<template>
  <div v-if="propertyDiff" class="diff">
    <span
      v-for="diffItem, key in propertyDiff"
      :key
      :class="{
        deleted: diffItem[0] < 0,
        same: diffItem[0] === 0,
        added: diffItem[0] > 0,
      }"
    >
      {{ diffItem[1] }}
    </span>
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.diff
  @apply inline
  .deleted
    @apply bg-$global-red-secondary
  .added
    @apply hidden
</style>
